import { Label } from "@/components/ui/label";
import { PlayerBuyInRow } from "@/components/PlayerBuyInRow";
import { AddPlayerRow } from "@/components/AddPlayerRow";
import type { SelectableCurrency } from "@/lib/constants";
import type { PlayerDraft } from "@/hooks/usePlayersState";

interface PlayerBuyInSectionProps {
  players: PlayerDraft[];
  currencySymbol: string;
  selectedCurrency: SelectableCurrency;
  cashInputValue: (playerId: string, storedRawValue: string) => string;
  beginCashEdit: (playerId: string, currentRawValue: string) => void;
  changeCashEdit: (playerId: string, nextValue: string) => void;
  endCashEdit: () => void;
  chipInputValue: (playerId: string, field: "chipsBought" | "finalChips", storedRawValue: string) => string;
  beginChipEdit: (playerId: string, field: "chipsBought" | "finalChips", currentRawValue: string) => void;
  changeChipEdit: (playerId: string, field: "chipsBought" | "finalChips", nextValue: string) => void;
  endChipEdit: (playerId: string, field: "chipsBought" | "finalChips") => void;
  updatePlayerName: (id: string, name: string) => void;
  removePlayer: (id: string) => void;
  pendingPlayerName: string;
  setPendingPlayerName: (name: string) => void;
  commitPendingPlayer: () => void;
  suggestedCashIn: number;
  suggestedChipsBought: number;
}

export function PlayerBuyInSection({
  players,
  currencySymbol,
  selectedCurrency,
  cashInputValue,
  beginCashEdit,
  changeCashEdit,
  endCashEdit,
  chipInputValue,
  beginChipEdit,
  changeChipEdit,
  endChipEdit,
  updatePlayerName,
  removePlayer,
  pendingPlayerName,
  setPendingPlayerName,
  commitPendingPlayer,
  suggestedCashIn,
  suggestedChipsBought,
}: PlayerBuyInSectionProps) {
  return (
    <div className="rounded-lg border p-3 md:p-4 space-y-3">
      <h2 className="font-semibold">1. Money in + chips bought</h2>
      <div className="grid grid-cols-[1.75rem_minmax(0,1fr)_5.25rem_5.25rem] gap-2 md:grid-cols-[1.75rem_2fr_1fr_1fr] md:gap-3">
        <span />
        <Label>Player</Label>
        <Label>Cash in ({selectedCurrency})</Label>
        <Label>Chips bought</Label>
      </div>

      <div className="space-y-3">
        {players.map((player, index) => (
          <PlayerBuyInRow
            key={player.id}
            player={player}
            rowLabel={index + 1}
            currencySymbol={currencySymbol}
            cashInputValue={cashInputValue}
            beginCashEdit={beginCashEdit}
            changeCashEdit={changeCashEdit}
            endCashEdit={endCashEdit}
            chipInputValue={chipInputValue}
            beginChipEdit={beginChipEdit}
            changeChipEdit={changeChipEdit}
            endChipEdit={endChipEdit}
            updatePlayerName={updatePlayerName}
            removePlayer={removePlayer}
          />
        ))}

        <AddPlayerRow
          pendingPlayerName={pendingPlayerName}
          setPendingPlayerName={setPendingPlayerName}
          commitPendingPlayer={commitPendingPlayer}
          currencySymbol={currencySymbol}
          suggestedCashIn={suggestedCashIn}
          suggestedChipsBought={suggestedChipsBought}
        />
      </div>
    </div>
  );
}
